import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import store from './store'
import VueSimpleSVG from 'vue-simple-svg'
import VueToast from 'vue-toast-notification'
import VueWait from 'vue-wait'
import { wait } from './utils/vuewait'
import 'vue-toast-notification/dist/theme-sugar.css'

Vue.config.productionTip = false

Vue.use(Vuelidate)

Vue.use(VueSimpleSVG)

Vue.use(VueToast)

Vue.use(VueWait)

require('@/styles/index.sass')
require('maz-ui/lib/css/index.css')

new Vue({
  router,
  store,
  wait,
  render: h => h(App)
}).$mount('#app')
